import { Plus, Upload, X } from "lucide-react";
import Loading from "../../shared/Loading";
import CustomSelect from "../../shared/CustomSelect";
import CustomInput from "../../shared/CustomInput";
import { useState } from "react";
import { uploadImage } from "../../sdk/upload/upload";

const AddGuarantorDocument = ({
  closeAddGuarantorDocument,
  setLoanDocuments,
  handleSubmitLoanDocument,
  loadingLoanDocument,
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [customName, setCustomName] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const finalDocName =
      selectedOption === "Others" ? customName : selectedOption;
    if (!finalDocName) return;

    try {
      const response = await uploadImage(file);
      const newDoc = {
        documentName: finalDocName,
        fileUrl: response?.url,
      };
      setLoanDocuments([newDoc]);
      setUploadedFile({ url: response?.url, name: file.name, type: file.type });
    } catch (error) {
      console.error("Upload failed", error);
    }
  };

  return (
    <div
      onClick={closeAddGuarantorDocument}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[580px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        {/* Close Button */}
        <div
          onClick={closeAddGuarantorDocument}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>

        {/* Action Button */}
        <div className="flex absolute bottom-[20px] right-[20px] items-center justify-end w-full">
          <button
            disabled={loadingLoanDocument}
            onClick={handleSubmitLoanDocument}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            {loadingLoanDocument ? (
              <Loading />
            ) : (
              <Plus size={16} color="#ffffff" />
            )}
            Add Document
          </button>
        </div>

        {/* Header */}
        <p className="text-[#000000] font-normal text-[14px]">
          Edit Loan Application
        </p>
        <p className="text-[#000000] font-semibold text-[20px]">
          Add a Guarantor Document
        </p>
        <p className="text-[#5C5C5C] text-[14px] font-normal">
          Upload a relevant document associated with the guarantor
        </p>

        <div className="my-[15px] w-full">
          {/* Select Document */}
          <div className="flex w-full mb-[10px] flex-col">
            <label className="text-[#222222] font-medium text-[13px]">
              Select Document
            </label>
            <CustomSelect
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              options={[
                "Job card / Tag",
                "Pay slip",
                "3 Month's Bank Statement",
                "6 Months Mpesa Statement",
                "12 Months Mpesa Statement",
                "Guarantor's ID",
                "Guarantor's Passport Photo",
                "KRA PIN",
                "PD Cheque",
                "Business Licenses",
                "Proof of Rent Payment",
                "Certificate of Registration and Incorporation",
                "Business Photos",
                "Statement: Bank, Till, Paybill, and Pochi",
                "Others",
              ]}
            />
          </div>

          {/* Show input only when "Others" is chosen */}
          {selectedOption === "Others" && (
            <div className="flex w-full mb-[10px] flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Document Name
              </label>
              <CustomInput
                placeholder="Enter your document name"
                type="text"
                value={customName}
                onChange={(e) => setCustomName(e.target.value)}
              />
            </div>
          )}

          {/* File Upload */}
          <div className="mb-[15px] w-full">
            <p className="text-[#222222] font-medium text-[13px]">
              Document upload{" "}
              <span className="font-normal text-[#5C5C5C]">
                .pdf or .docs file only
              </span>
            </p>
            <label htmlFor="fileInput">
              <div className="h-[130px] w-full flex flex-col justify-center items-center gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer">
                {uploadedFile ? (
                  <div className="px-[20px] flex items-center justify-center">
                    {uploadedFile.type.startsWith("image/") ? (
                      <img
                        src={uploadedFile.url}
                        alt="Uploaded"
                        className="h-[100px] object-contain"
                      />
                    ) : (
                      <p className="text-sm text-[#000000] text-center">
                        {uploadedFile.name}
                      </p>
                    )}
                  </div>
                ) : (
                  <>
                    <Upload />
                    <p className="text-[#000000] text-[12px] font-normal">
                      Drag and Drop file here or{" "}
                      <span className="text-[#000000] underline">
                        Choose file
                      </span>{" "}
                      here
                    </p>
                  </>
                )}
              </div>
            </label>
            <input
              type="file"
              accept=".jpeg,.jpg,.png,.pdf"
              className="hidden"
              id="fileInput"
              onChange={handleFileChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGuarantorDocument;
